import axios from "axios";

const configClient = axios.create({
  baseURL: process.env.CONFIG_FILES_LOCATION,
  headers: {
    Accept: "application/json",
  },
});

export default configClient;